export const CURRENT_USER = "CURRENT_USER";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_COMPLETED = "REGISTER_COMPLETED";
